import { createSlice } from "@reduxjs/toolkit";
import { createDynamicThunk, addApiCases } from "../../../../../service/requestHandler";

export const treeMapAccOpenApi = createDynamicThunk("treeMapAccOpenApi", "/report/api/v1/awsRMITController/RMIT/getRMITTreeMappedData", ["accountName"], "GET");

export const treeMapComplianceDrillDown = createDynamicThunk("treeMapComplianceDrillDown", "/report/api/v1/awsRMITController/RMIT/getComplianceListForRMITTreeMapWithSearch", ["accountName", "subTopic", "pageNumber", "itemsPerPage"]);

export const treeMapNonComplianceDrillDown = createDynamicThunk("treeMapNonComplianceDrillDown", "/report/api/v1/awsRMITController/RMIT/getRMITNonComplianceTreeMappedListWithSearch", ["accountName", "pageNumber", "itemsPerPage"]);

export const treeMapNotApplicableDrillDown = createDynamicThunk("treeMapNotApplicableDrillDown", "/report/api/v1/awsRMITController/RMIT/getNotApplicableListForRMITTreeMapWithSearch", ["accountName", "articleDescription", "pageNumber", "itemsPerPage"]);

export const chartDataApi = createDynamicThunk("chartDataApi", "/report/api/v1/awsRMITController/RMIT/GraphData", ["packName"]);

export const getResourceData = createDynamicThunk("getResourceData", "/report/api/v1/awsRMITController/RMIT/getResourceDataAndDescriptionsPagination", ["configRuleName", "accountName", "compliantType", "pageNumber", "itemsPerPage"]);


export const initialState = {
  treeMapAccOpenApiData: [],
  treeMapAccOpenApiLoading: false,
  treeMapComplianceDrillDownData: [],
  treeMapComplianceDrillDownLoading: false,
  treeMapNonComplianceDrillDownData: [],
  treeMapNonComplianceDrillDownLoading: false,
  treeMapNotApplicableDrillDownData: [],
  treeMapNotApplicableDrillDownLoading: false,
  chartDataApiData: [],
  chartDataApiDataLoading: false,
  getResourceDataData: [],
  getResourceDataLoading: false,
};

export const RMiTSlice = createSlice({
  name: "RMiTSlice",
  initialState,
  reducers: {
    resetRMiTSlice: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, treeMapAccOpenApi, "treeMapAccOpenApiData");
    addApiCases(builder, treeMapComplianceDrillDown, "treeMapComplianceDrillDownData");
    addApiCases(builder, treeMapNonComplianceDrillDown, "treeMapNonComplianceDrillDownData");
    addApiCases(builder, treeMapNotApplicableDrillDown, "treeMapNotApplicableDrillDownData");
    addApiCases(builder, chartDataApi, "chartDataApiData");
    addApiCases(builder, getResourceData, "getResourceDataData");
  },
});

export const { resetRMiTSlice } = RMiTSlice.actions;
export default RMiTSlice.reducer;
